import { useEffect } from "react";
import { api } from "@/lib/api";

/**
 * Applies theme (colors + fonts) from /api/content to the document root CSS vars.
 * Loads Google Font for custom choices.
 */
const LOADED_FONTS = new Set();
function loadGoogleFont(family) {
  if (!family || LOADED_FONTS.has(family)) return;
  const link = document.createElement("link");
  link.href = `https://fonts.googleapis.com/css2?family=${family.replace(/ /g, "+")}:wght@300;400;500;600;700&display=swap`;
  link.rel = "stylesheet";
  document.head.appendChild(link);
  LOADED_FONTS.add(family);
}

export default function ThemeProvider({ children }) {
  useEffect(() => {
    const applyTheme = (c) => {
      if (!c) return;
      const root = document.documentElement.style;
      if (c.theme_background) root.setProperty("--duo-off-white", c.theme_background);
      if (c.theme_surface) root.setProperty("--duo-sand", c.theme_surface);
      if (c.theme_accent) root.setProperty("--duo-gold", c.theme_accent);
      if (c.theme_primary) root.setProperty("--duo-brown", c.theme_primary);
      if (c.font_heading) {
        loadGoogleFont(c.font_heading);
        document.documentElement.style.setProperty("--duo-font-display", `'${c.font_heading}', Georgia, serif`);
      }
      if (c.font_body) {
        loadGoogleFont(c.font_body);
        document.documentElement.style.setProperty("--duo-font-body", `'${c.font_body}', sans-serif`);
      }
    };
    api.get("/content").then(({ data }) => applyTheme(data)).catch(() => {});
    const h = (e) => applyTheme(e.detail);
    window.addEventListener("duo:theme", h);
    return () => window.removeEventListener("duo:theme", h);
  }, []);

  return children;
}
